<template>
  <div class="Favorites">

    <slider :items="items" v-if="animal.id" />

  </div>
</template>

<script>
import Slider from 'components/Slider/Slider'

export default {
  name: 'Favorites',

  components: {
    Slider
  },

  computed: {
    animal () { return this.$store.state.animal },

    items () {
      return [
        {
          template: 'share',
          image: this.animal.image,
          content: {
            title: `Add ${this.animal.name} to your Favorites.`,
            footer: 'Download the PetSpace App; your companion<br> for all things PetSpace, and the home<br> of your favorited stories.'
          }
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Favorites.vue?4c412435